import type { CountryCode } from '@gql/graphql';
import type {
  CardItemBreederData,
  CardItemBreedSeoData,
  CardItemLitterData,
  ContactInfoData,
  HeaderProfileData,
  RelatedLinksData,
  SlideshowData,
} from '@presentation/components';
import type { LocationDescriptor } from 'history';
import type { ReactElement } from 'react';

export interface BreederPageContent {
  description?: string;
  activity?: string;
  housing?: string;
  health?: string;
  parentsSelection?: string;
  puppiesWork?: string;
}

export interface ReviewList {
  amount?: number;
  average?: number;
  loading?: boolean;
}

export interface BreederPageData {
  content?: BreederPageContent;

  header?: HeaderProfileData;
  contactInfo?: ContactInfoData;
  slideshow?: SlideshowData;
  breeds?: CardItemBreedSeoData[];
  litters?: CardItemLitterData[];
  reviewSummary?: ReviewList;
  reviewListComponent?: ReactElement;

  breedsLink: LocationDescriptor;
  breedNames?: string[];
  breederName: string;

  litterItems?: CardItemLitterData[];
  breederItems?: CardItemBreederData[];

  litterItemsLoading?: boolean;
  breederItemsLoading?: boolean;

  moreLittersLink: LocationDescriptor;
  moreBreedersLink: LocationDescriptor;

  relatedLinks?: RelatedLinksData;
  showApplyButton?: boolean;

  country?: CountryCode | null;

  onOpenBuyerChecklist(): void;
  onSocialShareClick(): void;
  whatsappNumber?: string | null;
  enableWhatsAppContact?: boolean;
  onWhatsappClick: () => void;
}

export interface BreederPageProps extends BreederPageData {}

export interface ReviewsFormValues {}
